import {
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { ChevronRightIcon } from '@clara/icons'

export const SettingsOption = ({
  title,
  description,
  icon,
  onClick,
}: {
  title?: string
  description?: string
  icon?: React.ReactNode
  onClick?: () => void
  height?: number
}) => (
  <>
    <ListItemButton onClick={onClick}>
      <ListItemIcon
        sx={{
          mr: 2,
        }}
      >
        {icon}
      </ListItemIcon>
      <ListItemText primary={title} secondary={description} />
      <ListItemIcon>
        <ChevronRightIcon fontSize="large" />
      </ListItemIcon>
    </ListItemButton>
    <Divider />
  </>
)
